import { render, staticRenderFns } from "./mycourse.vue?vue&type=template&id=5bbc725e&scoped=true"
import script from "./mycourse.vue?vue&type=script&lang=js"
export * from "./mycourse.vue?vue&type=script&lang=js"
import style0 from "./mycourse.vue?vue&type=style&index=0&id=5bbc725e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbc725e",
  null
  
)

export default component.exports